import styled from "styled-components";
import { theme } from "ui";

interface ColumnTableProps {
  color?: string;
}

export const BoxInfoShipping = styled.div`
  margin-top: 3rem;
  background-color: ${theme.colors.neutral.white};
  border-radius: 4px;
  border: 1px solid ${theme.colors.neutral["105"]};
  height: fit-content;
  min-width: ${theme.space.x64};
  max-width: ${theme.space.x194};
  min-height: ${theme.space.x20};
`;

export const FlagShipping = styled.div`
  display: flex;
  align-items: center;
  gap: 0.85rem;
  max-height: 2.5rem;
  width: fit-content;
  background: ${theme.colors.neutral.white};
  margin: -1.5rem 0 0 2rem;
  padding-right: ${theme.space.x6};
  border-radius: 0 4px 4px 0;
  border: 1px solid ${theme.colors.neutral["105"]};
`;

export const ShippingCircleIcon = styled.div`
  border: thin solid ${theme.colors.neutral["95"]};
  border-radius: 50%;
  margin-left: -1rem;
  background: ${theme.colors.neutral.white};
  overflow: hidden;
  height: 3.5rem;
  width: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TitleFlag = styled.div`
  font-weight: ${theme.typography.fontWeight["600"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.15rem;
  color: ${theme.colors.neutral["999"]};
  /* width: fit-content; */
`;

export const InfoTableShipping = styled.table`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  padding: 2rem 1.35rem 2rem 1.35rem;
`;

export const LineTable = styled.tr`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${theme.device.desktopFirst.tablet} {
    gap: 1.35rem;
  }

  @media ${theme.device.desktopFirst.mobileXL} {
    gap: 2.25rem;
  }
`;

export const ColumnArrivesTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;

export const ColumnArrivesText = styled.span`
  color: ${theme.colors.neutral["550"]};
  font-weight: ${theme.typography.fontWeight["400"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1rem;
`;

export const DescriptionText = styled.p`
  color: ${theme.colors.neutral["680"]};
  font-weight: ${theme.typography.fontWeight["400"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1rem;
`;

export const ShippingText = styled.h4`
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["500"]};
  font-family: ${theme.typography.fontFamily.chivo};
  /* max-width: ${theme.space.x44}; */
`;

export const ColumnTable = styled.td<ColumnTableProps>`
  font-weight: ${theme.typography.fontWeight["600"]};
  font-family: ${theme.typography.fontFamily.chivo};
  max-width: 6rem;
  color: ${({ color }) => color || theme.colors.neutral["999"]};
`;

export const ColumnTableFreeShipping = styled.div`
  padding: 0rem 0.65rem;
  border-radius: 16px;
  border: 1px solid ${theme.colors.secondary["250"]};
  background: ${theme.colors.secondary["380"]};
  height: fit-content;
`;
